import * as React from "react";
import { PluginStore } from "graylog-web-plugin/plugin";
import MissingRequirements from "views/components/views/MissingRequirements";
const _missingRequirements = (requirements, requirementsProvided) => Object.fromEntries(Object.entries(requirements).filter(([require]) => !requirementsProvided.includes(require)));
const RequirementsProvided = async ({ view, executionState }) => {
  const providedRequirements = PluginStore.exports("views.requires.provided");
  const missingRequirements = _missingRequirements(view.requires, providedRequirements);
  if (Object.keys(missingRequirements).length > 0) {
    const Component = () => /* @__PURE__ */ React.createElement(MissingRequirements, { view, missingRequirements });
    throw Component;
  }
  return [view, executionState];
};
export default RequirementsProvided;
